import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import SignIn from "./components/User/SignIn";
import { connect } from "react-redux";
import {
  get_paymentId,
  setCurrentLocale,
} from "./store/Actions/authActions";
import cookies from "js-cookie";
import BlackListRoutes from "./routes/AuthRoutes";
import WhiteListRoutes  from "./routes";

function App({ ...props }) {
  React.useEffect(()=>{
    cookies.set("laundryOnFoldedCloseStatus",'false');
    cookies.set("laundryOnHangerCloseStatus",'false');
  },[])


  const {hAddress, oAddress} = props
  useEffect(() => {
    if (props?.isAuthenticated === true) {
      // debugger
      // props
      //   .dispatch(getProducts())
      //   .then(() => props?.dispatch(fetchCartItem()));
      props.dispatch(get_paymentId());
      props.dispatch(
        setCurrentLocale({
          ...props?.newUser,
          user_locale:
            cookies.get("i18next") === "du"
              ? "du"
              : cookies.get("i18next") === "fn"
              ? "fn"
              : "en",
        })
      );
    }
  }, [props?.isAuthenticated]);

  const user_uid = props?.isAuthenticated ? true : false;
  function AuthedRoute({ component: Component, authed, ...rest }) {
    if (props?.newUser.new_user) {
      return (
        <Route
          {...rest}
          render={(props) =>
            authed === false ? (
              <Component {...props} />
            ) : (
              <Redirect
                to={{ pathname: "/use-wosh", state: { from: props.location } }}
              />
            )
          }
        />
      );
    }
     else {
      return (
        <Route
          {...rest}
          render={(props) =>
            authed === false ? (
              <Component {...props} />
            ) : (
              <Redirect
                to={{ pathname: hAddress?.length > 0 || oAddress?.length > 0 ? "/home" :"/use-wosh", state: { from: props.location } }}
              />

            )
          }
        />
      );
    }
  }

  const whiteList = [
    "/home",
    "/checkout",
    "/profile",
    "/paymentMethod",
    "/order",
    "/orders",
    "/",
  ]
  const blacklist = [
    "/personal-details",
    "/use-wosh",
    "/connect-point",
    "/delivery-details",
    "/thank-you",
    "/stripe-payment-success",
    "/mail-check/:email",
    "/forgot-password",
    "/unsub",
    "/wallet-success",
    "/reset-password/",
    "/purchase-success",
    "/new-user-password",
    "/invoice/:token",
    "/request-invoice/:token",
    "/c/:token",
  ]

  return (
    <>
    <Router>
         {/* {window.location.pathname === "/home" && <Header isNav={true} />} */}
      <Switch>
      <AuthedRoute
          authed={user_uid}
          path="/sign-in"
          exact
          component={SignIn}
        />
        <Route path={blacklist} render={(props) => <BlackListRoutes {...props}/>}  />
        <Route path={whiteList} render={(props) => <WhiteListRoutes {...props}/>}  />

      </Switch>
    </Router>
    </>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state?.auth?.isAuthenticated,
  newUser: state?.auth?.user,
  hAddress: state?.auth?.homeAddress,
  oAddress: state?.auth?.officeAddress,
});

export default connect(mapStateToProps)(App);
